module.exports = {
  INVALID_PROCESSING_HOUR: {
    message: 'Hora de processamento não permitida. Processamos boletos até às 19h',
    field: null,
    code: 'BIL_1'
  },
  IS_AFTER_DUE_DATE_ERROR_MESSAGE: {
    message: 'Não é possível pagar boletos após a data de vencimento',
    field: 'payment_date',
    code: 'BIL_2'
  },
  INVALID_BARCODE: {
    message: 'Linha digitável inválida',
    field: 'barcode',
    code: 'BIL_3'
  },
  MAX_VALUE: {
    message: 'Valor maior do que o permitido (R$ 250.000,00)',
    field: 'value',
    code: 'BIL_4'
  },
  INVALID_VALUE: {
    message: 'Valor não permitido',
    field: 'value',
    code: 'BIL_5'
  },
  EXPIRED_DUE_DATE: {
    message: 'Este código é de um boleto vencido',
    field: 'barcode',
    code: 'BIL_6'
  },
  BUSINESS_DAY: {
    message: 'Essa data não é um dia útil, selecione um dia útil para ser pago',
    field: 'payment_date',
    code: 'BIL_7'
  },
  DUPLICATED_BARCODE: {
    message: 'Linha digitável duplicada',
    field: 'barcode',
    code: 'BIL_8'
  },
  PAYMENT_DATE_IS_REQUIRED: {
    message: 'Data de pagamento é obrigatória',
    field: 'payment_date',
    code: 'BIL_9'
  },
  PAYMENT_DATE_WRONG_DATE: {
    message: 'Formato errado para a data de pagamento',
    field: 'payment_date',
    code: 'BIL_10'
  },
  PAYMENT_DATE_BEFORE_CURRENT_DATE: {
    message: 'Data de pagamento menor que a data atual',
    field: 'payment_date',
    code: 'BIL_11'
  },
  BATCH_WITHOUT_BILLETS: {
    message: 'Seu lote não tem boletos, registre boletos para fechar ele',
    field: null,
    code: 'BIL_12'
  },
  FORMAT_ERROR: {
    message: 'Formato do conteúdo de algum campo está diferente do esperado',
    field: null,
    code: 'BIL_13'
  },
  DUPLICATED_INTEGRATION_ID: {
    message: 'ID de integração duplicado',
    field: 'integration_id',
    code: 'BIL_14'
  },
  KEEPING_BALANCE_FOR_TOO_LONG: {
    message: 'Não é possível agendar boletos para mais de 30 dias',
    field: 'payment_date',
    code: 'BIL_15'
  },
  MIN_VALUE: {
    message: 'Valor do boleto deve ser maior do que R$0,00',
    field: 'value',
    code: 'BIL_16'
  },
  INVALID_BARCODE_OR_DIGITABLE_LINE: {
    message: 'Boleto com linha digitável ou código de barras inválido',
    field: 'barcode',
    code: 'BIL_17'
  },
  BILLET_NOT_REGISTERED: {
    message: 'Boleto não registrado',
    field: null,
    code: 'BIL_18'
  },
  BILLET_NOT_FOUND_FOR_CONSULTATION: {
    message: 'Boleto não encontrado para consulta',
    field: null,
    code: 'BIL_19'
  },
  BILLET_EXCEEDED_DEADLINE: {
    message: 'Boleto com data maior que a data limite de pagamento',
    field: null,
    code: 'BIL_20'
  },
  BILLET_ALREADY_PAID_CANT_CONSULT: {
    message: 'Boleto já foi pago, não é possível consultar os dados',
    field: null,
    code: 'BIL_21'
  },
  BILLET_AVAILABLE_FOR_PAYMENT: {
    message: 'Boleto está disponível para pagamento',
    field: null,
    code: 'BIL_22'
  },
  CANT_SCHEDULE_OVERDUE_BILLET: {
    message: 'Não é possível agendar pagamentos de boletos vencidos',
    field: 'payment_date',
    code: 'BIL_23'
  },
  CONSULT_REQUIRED_FOR_BILLETS: {
    message:
      'Para pagamento de boletos vencidos, com juros ou descontos é necessário fazer uma consulta em nossa API antes, assim garantimos o valor atualizado com multas, juros e descontos. Consulte a nossa documentação para mais detalhes',
    field: null,
    code: 'BIL_24'
  },
  MAX_DECIMAL_PLACES: {
    message: 'Valor do boleto não pode ter mais que 2 casas decimais',
    field: 'value',
    code: 'BIL_25'
  },
  RECEIPT_BATCH_DOWNLOAD_LIMIT_EXCEEDED: {
    message:
      'Foram identificados mais de {{maxBilletsAllowed}} boletos. Experimente aplicar mais filtros e tente novamente.',
    field: 'receipt_batch_download',
    variable: 'maxBilletsAllowed',
    code: 'BIL_26'
  }
};
